import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
export default class MatchesPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "matches", []);
    _defineProperty(this, "seasons", []);
    _defineProperty(this, "competitions", []);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "loadingMatches", false);
    _defineProperty(this, "matchesBySeason", {});
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "canDelete", false);
    // Filter states
    _defineProperty(this, "filter", '');
    _defineProperty(this, "selectedSeason", '');
    _defineProperty(this, "selectedCompetition", 'all');
    _defineProperty(this, "updatingCompetitionMatchId", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    this.canDelete = !!(app.forum.attribute('canDeleteMatches') || app.session.user && (app.session.user.attribute('canDeleteMatches') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    const compParam = m.route.param('competition');
    if (compParam) {
      this.selectedCompetition = String(compParam);
    }
    this.loadData();
  }
  loadData() {
    this.loading = true;
    m.redraw();
    Promise.all([app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
    }), app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/competitions'
    })]).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        seasonsResponse = _ref2[0],
        competitionsResponse = _ref2[1];
      this.seasons = app.store.pushPayload(seasonsResponse);
      this.competitions = competitionsResponse && competitionsResponse.data ? competitionsResponse.data.map(item => app.store.pushObject(item)) : [];

      // Set default selected season to the newest one
      if (this.seasons.length > 0 && !this.selectedSeason) {
        const sortedSeasons = [...this.seasons].sort((a, b) => b.name().localeCompare(a.name()));
        this.selectedSeason = String(sortedSeasons[0].id());
      }
      this.loading = false;
      m.redraw();
      if (this.selectedSeason) {
        this.loadMatchesForSeason(this.selectedSeason);
      }
    }).catch(error => {
      console.error('Error loading matches data:', error);
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_load'));
      this.loading = false;
      m.redraw();
    });
  }
  loadMatchesForSeason(seasonId) {
    if (!seasonId) return;
    if (this.matchesBySeason[seasonId]) {
      this.matches = this.matchesBySeason[seasonId];
      this.loadingMatches = false;
      m.redraw();
      return;
    }
    this.loadingMatches = true;
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches?season_id=".concat(seasonId, "&include=season,rival,team,competition")
    }).then(matchesResponse => {
      const seasonMatches = app.store.pushPayload(matchesResponse);
      this.matchesBySeason[seasonId] = Array.isArray(seasonMatches) ? seasonMatches : [seasonMatches];
      if (this.selectedSeason === seasonId) {
        this.matches = this.matchesBySeason[seasonId];
      }
    }).catch(error => {
      console.error('Error loading matches for season:', error);
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_load'));
    }).finally(() => {
      this.loadingMatches = false;
      m.redraw();
    });
  }
  quickChangeCompetition(match, newCompId) {
    this.updatingCompetitionMatchId = match.id();
    m.redraw();
    const competitionId = newCompId ? parseInt(newCompId) : null;
    app.request({
      method: 'PATCH',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches/".concat(match.id()),
      body: {
        data: {
          type: 'nagusi_matches',
          id: match.id(),
          attributes: {
            competitionId
          }
        }
      }
    }).then(response => {
      if (response && response.data) {
        app.store.pushPayload(response);
      }
      app.alerts.show({
        type: 'success'
      }, 'Competición del partido actualizada');
      delete this.matchesBySeason[this.selectedSeason];
      this.loadMatchesForSeason(this.selectedSeason);
    }).catch(err => {
      console.error('Error changing match competition:', err);
      app.alerts.show({
        type: 'error'
      }, 'Error al cambiar la competición del partido');
    }).finally(() => {
      this.updatingCompetitionMatchId = null;
      m.redraw();
    });
  }
  deleteMatch(id) {
    if (confirm(String(app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.confirm_delete')))) {
      app.request({
        method: 'DELETE',
        url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches/".concat(id)
      }).then(() => {
        app.alerts.show({
          type: 'success'
        }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.success_delete'));
        delete this.matchesBySeason[this.selectedSeason];
        this.loadMatchesForSeason(this.selectedSeason);
      }).catch(error => {
        console.error('Error deleting match:', error);
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_delete'));
      });
    }
  }
  formatDate(dateStr) {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    });
  }
  formatDateOnly(dateStr) {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString();
  }
  getMatchNameWithoutJornada(match) {
    const athletic = 'Athletic';
    // Use rival name if available, fallback to opponent attribute
    const rival = match.rival();
    const opponentName = rival ? rival.name() : match.opponent() || '';
    const isLocal = !!match.isLocal();
    const score = match.getScore();
    const localName = isLocal ? athletic : opponentName;
    const visitorName = isLocal ? opponentName : athletic;
    if (score) {
      const _score$split = score.split(' - '),
        _score$split2 = _slicedToArray(_score$split, 2),
        scoreLocal = _score$split2[0],
        scoreVisitor = _score$split2[1];
      return "".concat(localName, " ").concat(scoreLocal, " - ").concat(scoreVisitor, " ").concat(visitorName);
    }
    return "".concat(localName, " - ").concat(visitorName);
  }
  view() {
    if (!this.canManage) return null;
    const filteredMatches = this.matches.filter(match => {
      const name = match.getName() || '';
      const opponent = match.opponent() || '';
      const textMatch = name.toLowerCase().includes(this.filter.toLowerCase()) || opponent.toLowerCase().includes(this.filter.toLowerCase());
      const matchSeasonId = match.seasonId() ? String(match.seasonId()) : '';
      const seasonMatch = matchSeasonId === String(this.selectedSeason);
      const matchCompId = match.competitionId ? String(match.competitionId() || '') : match.competition && match.competition() ? String(match.competition().id()) : '';
      const compMatch = this.selectedCompetition === 'all' || matchCompId === String(this.selectedCompetition);
      return textMatch && seasonMatch && compMatch;
    })
    // Sort matches chronologically by matchDate (earliest to latest)
    .sort((a, b) => {
      const dateA = a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
      const dateB = b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
      return dateA - dateB;
    });
    const firstUnplayedMatch = filteredMatches.find(m => !m.getScore());
    return m("div", {
      className: "MatchesPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; gap: 15px; margin-bottom: 40px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), app.translator.trans('bizkaitarra-lineup.forum.matches.nav_back_taldezaina')), m(Link, {
      href: "/",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-home"
    }), app.translator.trans('bizkaitarra-lineup.forum.matches.nav_back_home')), firstUnplayedMatch && m("button", {
      type: "button",
      className: "Button Button--primary",
      onclick: () => {
        const el = document.getElementById("match-".concat(firstUnplayedMatch.id()));
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      },
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px;"
    }, m("i", {
      className: "fas fa-arrow-down"
    }), app.translator.trans('bizkaitarra-lineup.forum.matches.btn_first_unplayed'))), m("div", {
      className: "MatchesPage-header",
      style: "display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; flex-wrap: wrap; gap: 20px;"
    }, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.title')), m(Link, {
      href: app.route('bizkaitarra-lineup.matches.create'),
      className: "Button Button--primary",
      style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 8px; font-weight: bold; padding: 10px 20px;"
    }, m("i", {
      className: "fas fa-plus"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.matches.create_button'))), m("div", {
      className: "MatchesPage-filters",
      style: "margin-bottom: 35px; display: flex; gap: 15px; align-items: center; flex-wrap: wrap;"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 10px; flex: 1; min-width: 250px;"
    }, m("i", {
      className: "fas fa-search",
      style: "color: var(--muted-color);"
    }), m("input", {
      className: "FormControl",
      placeholder: app.translator.trans('bizkaitarra-lineup.forum.matches.search_placeholder'),
      value: this.filter,
      oninput: e => this.filter = e.target.value,
      style: "flex: 1; border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("div", {
      style: "display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-calendar-alt",
      style: "color: var(--muted-color);"
    }), m("select", {
      className: "FormControl",
      value: this.selectedSeason,
      onchange: e => {
        this.selectedSeason = e.target.value;
        this.loadMatchesForSeason(this.selectedSeason);
      },
      style: "width: auto; min-width: 180px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); height: 38px;"
    }, this.seasons.map(season => m("option", {
      value: season.id()
    }, season.name())))), m("div", {
      style: "display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-trophy",
      style: "color: var(--muted-color);"
    }), m("select", {
      className: "FormControl",
      value: this.selectedCompetition,
      onchange: e => {
        this.selectedCompetition = e.target.value;
        m.redraw();
      },
      style: "width: auto; min-width: 190px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); height: 38px;"
    }, m("option", {
      value: "all"
    }, "Todas las competiciones"), this.competitions.map(c => m("option", {
      value: String(c.id())
    }, c.nameEs ? c.nameEs() : c.name ? c.name() : c.slug()))))), this.loading || this.loadingMatches ? m(LoadingIndicator, null) : m("div", {
      className: "MatchesList-container"
    }, m("table", {
      className: "MatchesTable"
    }, m("thead", null, m("tr", null, m("th", {
      className: "col-partido"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.column_match')), m("th", {
      className: "col-competicion"
    }, "Competici\xF3n"), m("th", {
      className: "col-acciones"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.column_actions')))), m("tbody", null, filteredMatches.map(match => {
      return m("tr", {
        className: "MatchItem",
        id: "match-".concat(match.id()),
        key: match.id(),
        style: "border-bottom: 1px solid rgba(255,255,255,0.06); transition: background 0.2s ease;"
      }, m("td", {
        className: "col-partido"
      }, m("div", {
        style: "display: flex; flex-direction: column; gap: 4px;"
      }, m("span", {
        className: "Desktop-Only",
        style: "font-size: 1.1em; font-weight: bold; color: var(--heading-color);"
      }, match.renderName()), m("span", {
        className: "Mobile-Only",
        style: "font-size: 1.0em; font-weight: bold; color: var(--heading-color);"
      }, match.renderName({
        showJornada: false
      })), m("div", {
        style: "display: flex; align-items: center; gap: 8px; flex-wrap: wrap;"
      }, match.matchDate() && m("span", {
        style: "font-size: 0.85em; color: var(--muted-color); font-weight: 500;"
      }, this.formatDateOnly(match.matchDate())), typeof match.isKnockout === 'function' && match.isKnockout() && m("span", {
        style: "font-size: 0.75em; background: rgba(239, 68, 68, 0.12); color: #ef4444; border: 1px solid rgba(239, 68, 68, 0.3); border-radius: 4px; padding: 1px 6px; font-weight: 700; display: inline-flex; align-items: center; gap: 4px;"
      }, m("i", {
        className: "fas fa-trophy",
        style: "font-size: 0.8em;"
      }), "Eliminatoria", match.knockoutWinner && match.knockoutWinner() ? " (Pasa: ".concat(match.knockoutWinner() === 'Athletic' ? 'Athletic' : match.rival() ? match.rival().name() : match.opponent(), ")") : '')), typeof match.isSuspended === 'function' && match.isSuspended() && m("span", {
        style: "font-size: 0.82em; color: ".concat(match.isSuspendedWithLineup() ? '#10b981' : '#ef4444', "; font-weight: 600; margin-top: 2px;")
      }, m("i", {
        className: "fas ".concat(match.isSuspendedWithLineup() ? 'fa-check-circle' : 'fa-times-circle'),
        style: "margin-right: 4px;"
      }), match.isSuspendedWithLineup() ? '11 Aldeanos otorgado' : 'Sin 11 Aldeanos'), m("div", {
        className: "Mobile-Only",
        style: "margin-top: 6px;"
      }, (() => {
        const compId = match.competitionId ? String(match.competitionId() || '') : match.competition && match.competition() ? String(match.competition().id()) : '';
        const currentComp = this.competitions.find(c => String(c.id()) === compId);
        return m("div", {
          style: "display: flex; align-items: center; gap: 6px;"
        }, currentComp && currentComp.iconUrl && currentComp.iconUrl() && m("img", {
          src: currentComp.iconUrl(),
          alt: "",
          style: "width: 16px; height: 16px; object-fit: contain; flex-shrink: 0;"
        }), m("select", {
          className: "FormControl",
          value: compId,
          disabled: this.updatingCompetitionMatchId === match.id(),
          onchange: e => this.quickChangeCompetition(match, e.target.value),
          style: "border-radius: 6px; font-size: 0.8em; padding: 2px 6px; height: 28px; border: 1px solid rgba(255,255,255,0.15); background: rgba(255,255,255,0.05); color: inherit;"
        }, m("option", {
          value: ""
        }, "-- Sin competici\xF3n --"), this.competitions.map(c => m("option", {
          value: String(c.id())
        }, c.shortName ? c.shortName() : c.nameEs ? c.nameEs() : c.name()))));
      })()))), m("td", {
        className: "col-competicion",
        style: "vertical-align: middle; min-width: 180px;"
      }, (() => {
        const compId = match.competitionId ? String(match.competitionId() || '') : match.competition && match.competition() ? String(match.competition().id()) : '';
        const currentComp = this.competitions.find(c => String(c.id()) === compId);
        return m("div", {
          style: "display: flex; align-items: center; gap: 8px;"
        }, currentComp && currentComp.iconUrl && currentComp.iconUrl() ? m("img", {
          src: currentComp.iconUrl(),
          alt: "",
          style: "width: 20px; height: 20px; object-fit: contain; flex-shrink: 0;"
        }) : m("i", {
          className: "fas fa-trophy",
          style: "color: var(--muted-color); font-size: 0.85em; opacity: 0.4;"
        }), m("select", {
          className: "FormControl",
          value: compId,
          disabled: this.updatingCompetitionMatchId === match.id(),
          onchange: e => this.quickChangeCompetition(match, e.target.value),
          style: "border-radius: 6px; font-size: 0.85em; padding: 4px 8px; height: 32px; border: 1px solid ".concat(currentComp ? (currentComp.color() || '#fff') + '55' : 'rgba(255,255,255,0.15)', "; background: ").concat(currentComp ? (currentComp.color() || '#fff') + '15' : 'rgba(255,255,255,0.04)', "; color: inherit;")
        }, m("option", {
          value: ""
        }, "-- Sin competici\xF3n --"), this.competitions.map(c => m("option", {
          value: String(c.id())
        }, c.shortName ? "".concat(c.shortName(), " - ").concat(c.nameEs ? c.nameEs() : c.name()) : c.nameEs ? c.nameEs() : c.name()))));
      })()), m("td", {
        className: "col-acciones"
      }, m("div", {
        className: "Desktop-Only"
      }, m("div", {
        style: "display: inline-flex; gap: 6px; flex-wrap: wrap; justify-content: flex-end;"
      }, m(Link, {
        href: app.route('bizkaitarra-lineup.matches.edit', {
          id: match.id()
        }),
        className: "Button Button--secondary",
        style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 6px 10px; border: 1px solid rgba(255,255,255,0.15);",
        title: app.translator.trans('bizkaitarra-lineup.forum.matches.edit_data_title')
      }, m("i", {
        className: "fas fa-edit"
      }), app.translator.trans('bizkaitarra-lineup.forum.matches.btn_data')), m(Link, {
        href: app.route('bizkaitarra-lineup.matches.edit-score', {
          id: match.id()
        }),
        className: "Button Button--secondary",
        style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 6px 10px; border: 1px solid rgba(255,255,255,0.15);",
        title: app.translator.trans('bizkaitarra-lineup.forum.matches.edit_score_title')
      }, m("i", {
        className: "fas fa-futbol"
      }), app.translator.trans('bizkaitarra-lineup.forum.matches.btn_score')), m(Link, {
        href: app.route('bizkaitarra-lineup.matches.edit-participantes', {
          id: match.id()
        }),
        className: "Button Button--secondary",
        style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 6px 10px; border: 1px solid rgba(255,255,255,0.15);",
        title: app.translator.trans('bizkaitarra-lineup.forum.matches.edit_roster_title')
      }, m("i", {
        className: "fas fa-users"
      }), app.translator.trans('bizkaitarra-lineup.forum.matches.btn_roster')), this.canDelete && m(Button, {
        className: "Button Button--danger",
        onclick: () => this.deleteMatch(match.id()),
        style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 6px 10px; border: 1px solid rgba(255, 75, 75, 0.25); background: rgba(255, 75, 75, 0.05);",
        title: app.translator.trans('bizkaitarra-lineup.forum.matches.btn_delete')
      }, m("i", {
        className: "fas fa-trash"
      })))), m("div", {
        className: "Mobile-Only"
      }, m("div", {
        className: "Dropdown"
      }, m("button", {
        className: "Button Button--secondary Dropdown-toggle",
        "data-toggle": "dropdown",
        style: "border-radius: 8px; font-weight: bold; display: inline-flex; align-items: center; gap: 6px;"
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.actions_mobile_btn'), " ", m("i", {
        className: "fas fa-caret-down"
      })), m("ul", {
        className: "Dropdown-menu Dropdown-menu--right"
      }, m("li", null, m(LinkButton, {
        href: app.route('bizkaitarra-lineup.matches.edit', {
          id: match.id()
        }),
        icon: "fas fa-edit"
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.btn_data'))), m("li", null, m(LinkButton, {
        href: app.route('bizkaitarra-lineup.matches.edit-score', {
          id: match.id()
        }),
        icon: "fas fa-futbol"
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.btn_score'))), m("li", null, m(LinkButton, {
        href: app.route('bizkaitarra-lineup.matches.edit-participantes', {
          id: match.id()
        }),
        icon: "fas fa-users"
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.btn_roster'))), this.canDelete && m("li", {
        className: "Dropdown-separator"
      }), this.canDelete && m("li", null, m(Button, {
        icon: "fas fa-trash",
        onclick: () => this.deleteMatch(match.id())
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.btn_delete'))))))));
    }))), filteredMatches.length === 0 && m("p", {
      style: "text-align: center; padding: 25px; color: var(--muted-color); font-style: italic; margin: 0;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.no_matches')))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/MatchesPage', MatchesPage);